<template>
    <div>
        <header v-if="!isPreLoad" class="p-3">
            <div class="flex-titular">
                <div>
                    <h1 v-cloak>{{ translator.incidencia }}</h1>

                </div>

                <div class="text-right">
                    <router-link class="link-atras" :to="{ name: 'Service', query: { id: $route.query.id } }">
                        <i class="fal fa-undo-alt"></i>
                    </router-link>
                </div>
            </div>
        </header>

        <div class="pc service">

            <!-- Spiner -->
            <div v-if="isPreLoad" style="height: 90vh; display:flex; justify-content:center; align-items:center;">
                <div class="hollow-dots-spinner">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                </div>
            </div>
            <!-- Fin spiner -->
            <!-- Titular y información incidencia -->
            <div v-if="serviceDetail.lodging_name && !isPreLoad" class="container incidencia p-4">
                <div class="row incidencia-titulo mb-4">
                    <div class="col">
                        <h5>{{ serviceDetail.service_headline }}</h5>
                    </div>
                </div>

                <div v-if="!validService" class="alert alert-warning" role="alert">
                    *Debe subir una imagen o añadir una descripción*
                </div>

                <div class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular pt-1">
                        {{ translator.estat }}
                    </div>
                    <div class="col pt-1">
                        {{ serviceDetail.status }}
                    </div>
                    <div class="col-5">
                        <button @click.prevent.stop="endService" class="btn btn-primary btn-sm btn-cerrar-incidencia">{{
                            translator.tancarincidencia }}</button>
                    </div>
                </div>
                <div class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular">
                        {{ translator.data }}
                    </div>
                    <div class="col">
                        {{ serviceDetail.service_date | transformDate }}
                    </div>
                </div>
                <div class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular">
                        {{ translator.propietat }}
                    </div>
                    <div class="col">
                        <a :href="`https://www.google.com/maps/search/?api=1&query=${serviceDetail.lodging_latitude},${serviceDetail.lodging_longitude}`"
                            target="_blank">
                            <i class="fal fa-map-marker-alt"></i>
                            {{ serviceDetail.lodging_name }}
                        </a>
                    </div>
                </div>
                <div v-if="serviceDetail.service_priority != ''" class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular">
                        {{ translator.motiuincidencia }}
                    </div>
                    <div class="col">
                        {{ serviceDetail.service_priority }}
                    </div>
                </div>
                <div class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular">
                        {{ translator.motiuincidencia }}
                    </div>
                    <div class="col">
                        {{ serviceDetail.service_reason }}
                    </div>
                </div>
                <!-- Es edificio -->
                <!-- <div v-if="lodging_type == 'building' && serviceDetail.lodging_zone !== ''"
                    class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular">
                        <i class="fa-light fa-building"></i>
                    </div>
                    <div class="col">
                        {{ serviceDetail.lodging_zone }}
                    </div>
                </div> -->
                <div class="row incidencia-info py-2">
                    <div class="col-3 incidencia-titular">
                        {{ translator.observacions }}
                    </div>
                    <div class="col">
                        {{ serviceDetail.service_text }}
                    </div>
                </div>

                <!-- Botón para ver el informe PDF -->
                <div v-if="serviceDetail.inventory.length > 0"
                    class="row incidencia-info py-2 incidencia-border-bottom">

                    <div class="col-12 incidencia-titular" type="button" data-toggle="collapse"
                        data-target="#collapseInventory" aria-expanded="false" aria-controls="collapseInventory"
                        @click="toggleIcon = !toggleIcon">
                        {{ translator.inventari }}
                        <i v-if="toggleIcon" class="fa-light fa-circle-chevron-up"></i>
                        <i v-else class="fa-light fa-circle-chevron-down"></i>
                    </div>

                    <div class="collapse" id="collapseInventory">
                        <div class="card">

                            <div class="d-flex justify-content-between mt-4"
                                style="border-bottom: 1px solid #bfc1c256;">
                                <div class="col-6">{{ translator.nom }}</div>

                                <div class="col-6 d-flex">
                                    {{ translator.datarevisio }}
                                </div>
                            </div>
                            <div v-for="objeto in serviceDetail.inventory" :key="objeto.inventory_id"
                                class="d-flex justify-content-between mt-4">
                                <a @click="seleccionarObjetoInventario(objeto)" href="" class="col-6"
                                    data-toggle="modal" data-target="#modalItem">{{
                                        objeto.inventory_name }}</a>

                                <div class="col-6 d-flex">
                                    {{ objeto.inventory_revision | transformDate }}
                                </div>
                            </div>
                        </div>

                        <!-- Modal -->
                        <div v-if="objetoInventarioSeleccionado" class="modal fade" id="modalItem" tabindex="-1"
                            aria-labelledby="modalItemLabel" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="modalItemLabel">
                                            {{ objetoInventarioSeleccionado.inventory_name }}
                                        </h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">

                                        <p v-if="objetoInventarioSeleccionado.inventory_brad != ''" class="col-12">
                                            <b>{{ translator.marca }}:</b>
                                            <span class="ml-2">{{ objetoInventarioSeleccionado.inventory_brad }}</span>
                                        </p>
                                        <p v-if="objetoInventarioSeleccionado.inventory_serial_number != ''"
                                            class="col-12"><b>{{ translator.numeroserie }}:</b>
                                            <span class="ml-2">{{ objetoInventarioSeleccionado.inventory_serial_number
                                            }}</span>
                                        </p>
                                        <p v-if="objetoInventarioSeleccionado.inventory_date != ''" class="col-12">
                                            <b>{{ translator.dataregistre }}:</b>
                                            <span class="ml-2">{{ objetoInventarioSeleccionado.inventory_date }}</span>
                                        </p>
                                        <p v-if="objetoInventarioSeleccionado.inventory_revision != ''" class="col-12">
                                            <b>{{ translator.datarevisio }}:</b>
                                            <span class="ml-2">{{ objetoInventarioSeleccionado.inventory_revision
                                            }}</span>
                                        </p>

                                        <div v-if="objetoInventarioSeleccionado.inventory_documents.length > 0"
                                            class="col-6 d-flex flex-column">
                                            <p><b>{{ translator.manuals }}:</b></p>
                                            <div v-for="obj in objetoInventarioSeleccionado.inventory_documents"
                                                :key="obj.document_id" @click="openPDF(obj.document_pdf)"
                                                class="mx-2 link-pdf">
                                                {{ obj.document_name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary"
                                            data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- Fotos del antes -->
                <h6 class="mt-4 mb-3">
                    {{ translator.fotos }}:
                </h6>
                <div class="row mb-3"
                    v-if="serviceDetail.service_image_1 != '' || serviceDetail.service_image_2 != '' || serviceDetail.service_image_3 != ''">
                    <div class="col-4">
                        <img :src="serviceDetail.service_image_1" class="img-fluid" />
                    </div>
                    <div class="col-4">
                        <img :src="serviceDetail.service_image_2" class="img-fluid" />
                    </div>
                    <div class="col-4">
                        <img :src="serviceDetail.service_image_3" class="img-fluid" />
                    </div>
                </div>

                <!-- Subida y muestra de fotos del después -->
                <div class="row mb-2">
                    <div class="col-4">
                        <img v-if="serviceDetail.service_image_4 != ''" :src="serviceDetail.service_image_4"
                            class="img-fluid">
                    </div>
                    <div class="col-4">
                        <img v-if="serviceDetail.service_image_5 != ''" :src="serviceDetail.service_image_5"
                            class="img-fluid">
                    </div>
                    <div class="col-4">
                        <img v-if="serviceDetail.service_image_6 != ''" :src="serviceDetail.service_image_6"
                            class="img-fluid">
                    </div>
                </div>

                <!-- Boton guardar fotos -->
                <div class="row">
                    <image-uploader v-if="numPhoto > 0" id="image4" :debug="1" :maxWidth="1024" :quality="0.9"
                        :autoRotate="false" class="col-12" :className="['fileinput']" outputFormat="verbose"
                        :preview="false" :capture="false" accept="image/*" doNotResize="['gif', 'svg']"
                        @input="savePhotoService">
                        <label for="image4" slot="upload-label">
                            <span class="btn btn-outline-secondary mt-1" style="width: initial;">
                                {{ translator.pujarimatge }}
                            </span>
                        </label>
                    </image-uploader>
                </div>

                <!-- Reporte de informe -->
                <h6 class="mt-4 mb-2">{{ translator.informe }}:</h6>
                <textarea v-model="serviceReport" class="form-control" rows="6"> </textarea>

                <!-- Precio -->
                <h6 class="mt-4 mb-2">{{ translator.import }}: </h6>
                <div class="input-group mb-3">
                    <input id="priceReport" type="text" v-model="servicePrice" class="col-3 form-control">
                    <div class="input-group-append">
                        <span class="input-group-text">{{ serviceDetail.service_currency }}</span>
                    </div>
                </div>

                <button
                    v-if="serviceReport == serviceDetail.service_report && servicePrice == serviceDetail.service_import && servicePhotos == 0"
                    class="btn btn-outline-primary mt-1" disabled>
                    {{ translator.guardar }} {{ translator.informe | toLower }}
                </button>
                <button v-else @click="serveiGuardar" class="btn btn-primary mb-2">
                    <i class="fal fa-save pr-1"></i>
                    {{ translator.guardar }} {{ translator.informe | toLower }}
                </button>
            </div>

            <NavbarService :translator="translator" :user="user" />
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState } from "vuex";
import NavbarService from "@/components/NavbarService.vue";


export default {
    name: "ServiceDetail",
    components: {
        NavbarService,
    },
    computed: {
        ...mapState("utils", ["user", "translator"]),
        ...mapState("service", ["serviceDetail"]),
    },
    watch: {
        translator() {
            this.$store.dispatch("service/getServiceDetail", { usr: this.$route.query.id, id: this.$route.params.service });
        },
        serviceDetail() {
            this.isPreLoad = false;
            this.servicePrice = this.ereaseZero(this.serviceDetail.service_import);
            this.serviceReport = this.serviceDetail.service_report;
            if (this.serviceDetail.service_image_4 == '') {
                this.numPhoto = 4
            } else if (this.serviceDetail.service_image_5 == '') {
                this.numPhoto = 5
            } else if (this.serviceDetail.service_image_6 == '') {
                this.numPhoto = 6
            } else {
                this.numPhoto = 0
            }
        }
    },
    data() {
        return {
            isPreLoad: false,
            isInitLoad: true,
            servicePhotos: [],
            numPhoto: 0,
            serviceReport: '',
            servicePrice: '',
            validService: true,
            toggleIcon: false,
            objetoInventarioSeleccionado: null
        };
    },

    async created() {
        try {
            this.isPreLoad = true;
            this.translator
                ? await this.$store.dispatch("service/getServiceDetail", { usr: this.$route.query.id, id: this.$route.params.service })
                : await this.$store.dispatch("utils/getUser", { usr: this.$route.query.id });
        } catch (error) {
            console.error(error);
        }
    },

    mounted() {
        // Detectar eventos de Bootstrap para cambiar el icono
        $('#collapseInventory').on('show.bs.collapse', () => {
            this.toggleIcon = true;
        });

        $('#collapseInventory').on('hide.bs.collapse', () => {
            this.toggleIcon = false;
        });
    },
    beforeDestroy() {
        // Limpiar los event listeners cuando el componente se destruye
        $('#collapseInventory').off('show.bs.collapse');
        $('#collapseInventory').off('hide.bs.collapse');
    },

    methods: {

        seleccionarObjetoInventario(objeto) {
            this.objetoInventarioSeleccionado = objeto;
        },

        savePhotoService(photo) {
            this.image = photo;
            console.log(photo);

            this.servicePhotos.push({
                'img': this.numPhoto,
                'foto': photo.dataUrl
            });
            this.serveiEnviarFotos()

        },

        serveiEnviarFotos() {
            try {
                this.isPreLoad = true;
                let img4 = "", img5 = "", img6 = "";

                // Asignación botón con su número de foto
                for (const value of this.servicePhotos) {
                    if (value.img === 4) {
                        img4 = value.foto;
                    } else if (value.img === 5) {
                        img5 = value.foto;
                    } else if (value.img === 6) {
                        img6 = value.foto;
                    }
                }

                // Envia info a la store para hacer el post
                this.$store.dispatch("service/postServeiEnviarFotos", { usr: this.$route.query.id, id: this.$route.params.service, image4: img4, image5: img5, image6: img6 });

                // Reset fotos
                this.servicePhotos = [];
                this.validService = true;
            } catch (error) {
                console.error(error);
            } finally {
                setTimeout(() => {
                    this.isPreLoad = false;
                }, 7000);
            }
        },

        serveiGuardar() {
            try {
                this.isPreLoad = true;
                this.serviceReport != this.serviceDetail.service_report || this.servicePrice != this.serviceDetail.service_import
                    ? this.$store.dispatch("service/postServeiGuardarInforme", { usr: this.$route.query.id, id: this.$route.params.service, informe: this.serviceReport, preu: this.servicePrice })
                    : '';
                this.$toast.success(this.translator.guardat);
                this.validService = true;
            } catch (error) {
                console.error(error)
            }
        },

        async endService() {
            if (this.serviceDetail.service_image_4 == '' && this.serviceDetail.service_image_5 == '' && this.serviceDetail.service_image_6 == '' && this.serviceDetail.service_report == '') {
                this.validService = false;

            } else {
                this.validService = true;
                try {
                    this.isPreLoad = true;
                    await this.$store.dispatch("service/postEndService", { usr: this.$route.query.id, id: this.$route.params.service });
                    // Feedback al usuario
                    this.$toast.success(this.translator.guardat);
                    setTimeout(() => this.$router.push({ name: 'Service', query: { id: this.$route.query.id } }), 1000);
                } catch (error) {
                    console.error(error)
                } finally {
                    this.isPreLoad = false;
                }
            }
        },

        base64ToArrayBuffer(base64) {
            const binaryString = window.atob(base64);
            const binaryLen = binaryString.length;
            const bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
                let ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        openPDF(byte) {
            const pdf = this.base64ToArrayBuffer(byte)
            const blob = new Blob([pdf], { type: "application/pdf" });
            const fileUrl = window.URL.createObjectURL(blob);

            function detectMob() {
                const toMatch = [
                    /Android/i,
                    /webOS/i,
                    /iPhone/i,
                    /iPad/i,
                    /iPod/i,
                    /BlackBerry/i,
                    /Windows Phone/i
                ];
                return toMatch.some((toMatchItem) => {
                    return navigator.userAgent.match(toMatchItem);
                });
            }

            detectMob()
                ? window.open(fileUrl, "_self")
                : window.open(fileUrl);
        },

        ereaseZero(value) {
            if (!value) return "";
            value = String(value.includes(".00")) ? String(value).replace(".00", "") : ''
            return value;
        },

    },

    filters: {
        transformDate(value) {
            if (!value) return '';
            const backendDate = value.split('-');
            return `${backendDate[2]}/${backendDate[1]}/${backendDate[0]}`;
        },
        toLower(value) {
            if (!value) return "";
            value = value.toString();
            return value.toLowerCase();
        }
    },

}
</script>

<style>
header .flex-titular {
    display: flex;
    justify-content: space-between;
    max-width: 752px;
    margin: auto;
}

header .link-atras {
    padding: 12px;
    color: #FFF;
}

header .link-atras:hover {
    color: #b5b5b5;
}

.fileinput {
    display: none;
}

.img-preview {
    max-width: 100%;
    height: auto;
}

input[type="file"]#camera0,
input[type="file"]#camera1,
input[type="file"]#camera2 {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.incidencia-titular {
    opacity: 0.6;
    font-size: 14px;
}

.incidencia-border-bottom {
    border-bottom: 1px solid #bfc1c256;
}

.btn-cerrar-incidencia {
    width: auto;
    position: absolute;
    right: 10px;
}

.input-group-text {
    border-right: 1px solid;
}

@media (max-width: 470px) {
    .btn-cerrar-incidencia {
        position: inherit;
        width: auto;
        margin: auto;
    }
}

.alert-dismissible .close {
    padding: 0 1.25rem;
}

.link-pdf {
    cursor: pointer;
    color: blue
}
</style>